import { render, staticRenderFns } from "./GED.vue?vue&type=template&id=6404ab2b&scoped=true&lang=pug&"
import script from "./GED.vue?vue&type=script&lang=coffee&"
export * from "./GED.vue?vue&type=script&lang=coffee&"
import style0 from "./GED.vue?vue&type=style&index=0&id=6404ab2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6404ab2b",
  null
  
)

export default component.exports